module.exports = __webpack_public_path__ + "static/img/hero-koza.740a063.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/hero-koza.png
// module id = PL/G
// module chunks = 0